{
  "navigation": {
    "main": "MAIN",
    "dashboard": "Dashboard",
    "issues": "Tickets",
    "inbox": "Inbox",
    "outbox": "Outbox",
    "my_issues": "My Tickets",
    "watching": "Watching Tickets",
    "create_issue": "Create a Ticket",
    "create_new": "New Ticket",
    "select_template": "Templates",
    "application": "APPLICATION",
    "settings": "Settings",
    "partnership": "Partner",
    "role_management": "Role Management",
    "inbox_routing": "Inbox Rules",
    "outbox_routing": "Outbox Rules",
    "sla_config": "SLA",
    "light_partner_config": "Light Partner Config",
    "help": "Help",
    "release_notes": "Release Notes",
    "migration": "Migration"
  },
  "inbox_tickets": "Inbox Tickets",
  "outbox_tickets": "Outbox Tickets",
  "my_tickets": "My Tickets",
  "watching_tickets": "Watching Tickets",
  "unknown_ticket_type": "Unknown Ticket Type",
  "ticket": "Ticket",
  "refresh": "Refresh",
  "severity_change_bnetza": "Case id of 'Bundesnetzagentur",
  "mark_all_as_read": "Mark all as read",
  "no_notifications": "There are no notifications",
  "new": "new",
  "stats": {
    "total_tickets": "Total Tickets",
    "since_last_week": "since last week",
    "all_time": "Total",
    "this_week": "This Week",
    "this_month": "This Month",
    "show_all_partners": "Show All Partners",
    "show_top_partners": "Show Top {{count}} + Other",
    "filter_partner": "Filter Partner",
    "filter_partners": "Filter Partners",
    "partners_selected": "{0} partners selected",
    "in_progress_tickets": "In Progress",
    "resolved_tickets": "Resolved Tickets",
    "closed_tickets": "Closed Tickets",
    "no_my_issues": "You do not have any tickets assigned to you."
  },
  "clear_filters": "Clear Filters",
  "filters": "Filters",
  "unread": "Unread",
  "sla_warning": "Resolution deadline approaching",
  "sla_exceeded": "Resolution deadline exceeded",
  "deadline_warning": "Resolution deadline approaching",
  "deadline_exceeded": "Resolution deadline exceeded",
  "category": "Category",
  "creation_date": "Creation Date",
  "originator": "Originator",
  "finished_only": "Finished Only",
  "all_tickets": "All Tickets",
  "active_tickets": "Active Tickets",
  "ticket_scope_active": "Active",
  "ticket_scope_all": "All",
  "ticket_scope_closed": "Closed",
  "not_resolved_only": "Not Resolved Only",
  "processor": "Processor",
  "severity": "Severity",
  "status": "Current Status",
  "actions": "Actions",
  "partner_actions": "Partner Actions",
  "internal_actions": "Internal Actions",
  "no_available_actions": "No available actions",
  "activity": "Activity",
  "overview": "Overview",
  "description": "Description",
  "status_change_reason": "Status Change Reason",
  "status_change_date": "Status Change Date",
  "last_update": "Last Update",
  "updated_short": "Updated",
  "requested_resolution_date": "Requested Resolution Date",
  "severity_change_reason": "Severity Change Reason",
  "resolve_attachments": "Resolve Attachments",
  "attachments": "Attachments",
  "no_attachments": "No attachments provided",
  "resolved_successfully": "Ticket resolved successfully?",
  "resolved_successfully_short": "Resolved successfully?",
  "ticket_resolved_positively": "Positively resolved",
  "resolved_successfully_yes": "Resolved successfully: Yes",
  "resolved_successfully_no": "Resolved successfully: No",
  "ticket_resolved_unsuccessfully": "Negatively resolved",
  "ticket_reklamiert": "Reclaimed",
  "assignee": "Assignee",
  "any": "Any",
  "no_table_tickets": "No tickets found.",
  "total_table_tickets": "The total number of records matching the specified filter is {{totalRecords}}",
  "clearing_ticket": "Clearing Ticket",
  "all": "All",
  "notes": "Notes",
  "internal_notes": "Internal Notes",
  "status_changes": "Status Changes",
  "severity_changes": "Severity Changes",
  "assignment_changes": "Assignment Changes",
  "assign_to_me": "Assign to Me",
  "request_cancellation": "Request Cancellation",
  "successfully_requested_cancellation": "Successfully requested cancellation",
  "watch": "Watch",
  "unwatch": "Unwatch",
  "search": "Search",
  "critical": "Critical",
  "regular": "Regular",
  "escalated": "Escalated",
  "acknowledged": "Acknowledged",
  "pending": "Pending",
  "held": "On Hold",
  "inProgress": "In Progress",
  "cancelled": "Cancelled",
  "closed": "Closed",
  "resolved": "Resolved",
  "final": "Finalized",
  "unknown_status": "Status Unknown",
  "create_an_issue": "Create a Ticket",
  "scenario": "Scenario",
  "main_scenario": "Main Scenario",
  "select_scenario": "Select a Scenario",
  "select_severity": "Select a Severity",
  "select_processor": "Select a Processor",
  "scenario_is_mandatory": "Please select a ticket scenario to continue.",
  "mandatory": "mandatory",
  "optional": "optional",
  "external_id": "External ID",
  "back": "Back",
  "next": "Next",
  "submit": "Submit",
  "details": "Details",
  "clearing_data": "Clearing Data",
  "select_originator": "Select Originator",
  "scenario_filter_placeholder": "Filter (e.g. 2.1.08)",
  "no_matches": "No matches",
  "edit_template": "Edit Template",
  "save_as_template": "Save as Template",
  "drop_files_here": "Drag and drop files here to upload.",
  "name": "Name",
  "no_templates": "No available templates.",
  "delete": "Delete",
  "select": "Select",
  "clearing_ticket_templates": "Clearing Ticket Templates",
  "delete_template_confirmation": "Are you sure you want to delete {{name}} template?",
  "yes": "Yes",
  "no": "No",
  "successfully": "Success",
  "sla_config_deleted_successfully": "SLA Configuration has been deleted successfully!",
  "template_deleted": "Template {{name}} successfully deleted",
  "routing_inbox": "Inbox Routing Configuration",
  "routing_outbox": "Outbox Routing Configuration",
  "create_new": "Create new",
  "routing_group": "Routing Rule",
  "active_directory_role": "App Role",
  "scenarios": "Scenarios",
  "no_routing_configurations": "No routing rules found.",
  "create_routing_rule": "Create Routing Rule",
  "routing_group_name": "Routing Rule Name",
  "routing_owner_name": "Routing Owner Name",
  "create_additional_role": "Create Additional Role",
  "new_role_name": "New Role Name",
  "inherited_base_role": "Inherited Base Role",
  "create_role": "Create Role",
  "please_fill_required_fields": "Please fill out all required fields",
  "no_roles_found": "No roles found.",
  "role_created_success": "Role {{name}} created.",
  "select_a_role": "Select a Role",
  "select_a_owner": "Select a Owner",
  "available_scenarios": "Available Scenarios",
  "selected_scenarios": "Selected Scenarios",
  "search_by_name": "Search by Name",
  "update": "Update",
  "create": "Create",
  "edit": "Edit",
  "delete_routing_config": "Are you sure you want to delete {{name}} routing rule?",
  "edit_routing_config": "Edit {{name}} Routing Rule",
  "partner_itu_code": "Partner ITU Code",
  "owner_itu_code": "Owner ITU Code",
  "scenarios_covered": "Covered Scenarios",
  "supported_scenarios_success": "Successfully selected supported scenarios",
  "regular_resolution_time": "Regular Resolution Time",
  "regular_resolution_warning_time": "Regular Resolution Warning Time",
  "critical_resolution_time": "Critical Resolution Time",
  "critical_resolution_warning_time": "Critical Resolution Warning Time",
  "escalated_resolution_time": "Escalated Resolution Time",
  "escalated_resolution_warning_time": "Escalated Resolution Warning Time",
  "no_sla_configurations": "No SLA Configurations found.",
  "sla_configuration": "SLA Configuration",
  "create_sla_config": "Create SLA Configuration",
  "hours": "hours",
  "delete_sla_config": "Are you sure you want to delete this SLA Configuration?",
  "contractNumber": "Contract Number",
  "externalIdentifier": "List of External Identifiers",
  "externalIdentifierType": "External Order/Identification Number: Type",
  "id": "External Identifiers",
  "ndc": "ONKZ",
  "phone": "Phone Data",
  "telephone": "Phone",
  "blockPrefix": "Direct Dial Number - Number Block Prefix",
  "blockStart": "Number Block From",
  "blockEnd": "Number Block To",
  "sn": "Phone Number",
  "customer": "Customer Data",
  "individual": "Customer Data - Individual",
  "givenName": "First Name",
  "familyName": "Last Name",
  "organization": "Customer Data - Company",
  "tradingName": "Company",
  "address": "Address Data",
  "requestedDate": "Customer Requested Date (CRD)",
  "confirmedDate": "Confirmed Delivery Date",
  "agreedSwitchDate": "Agreed Switch Date",
  "portingDate": "Porting Date (PD)",
  "prolongationDate": "Extended Service Until",
  "prolongationCompleted": "Extended Service Completed",
  "prolongationChange": "Reason for Extended Service",
  "initialSwitchDate": "Original Switch Date",
  "troubleTicketToBeClearedCreationDate": "Trouble Ticket Creation Date",
  "pkiAuf": "Receiving Port Identification Owner (PKIauf)",
  "pkiAbg": "Releasing Port Identification Owner (PKIabg)",
  "ekpAuf": "ITU Code of Receiving Customer Contract Partner (EKPauf)",
  "ekpAbg": "ITU Code of Releasing Customer Contract Partner (EKPabg)",
  "nga": "Next Generation Access Operator",
  "additionalInformation": "Information/Actions/Free Text",
  "troubleTicketRequest": "Troubleshooting Appointment",
  "error": "Error Data",
  "forbidden": {
    "summary": "Forbidden",
    "detail": "You do not have rights to access this page"
  },
  "testCall": "Test Call Data",
  "specialAgreements": "Bilateral Agreements",
  "streetName": "Street Name",
  "streetNr": "House Number",
  "streetNrSuffix": "House number add-on",
  "city": "City",
  "postcode": "Zip Code",
  "locality": "Locality",
  "code": "Error Code",
  "text": "Error Text",
  "source": "Testcall: A-Number",
  "destination": "Testcall: B-Number",
  "timestamp": "Timestamp",
  "statusCode": "Trigger Reason",
  "validFor": "Valid for fault clearance date",
  "startDateTime": "Fault clearance date (start)",
  "endDateTime": "Fault clearance date (end)",
  "externalIdentifier[externalOrderId]": "External Order Number",
  "externalIdentifier[lineId]": "Line ID",
  "externalIdentifier[prenegotiationId]": "Pre-negotiation ID (WBCI-ID)",
  "externalIdentifier[prenegotiationChangeId]": "Cancellation or Rescheduling ID (WBCI-ID)",
  "externalIdentifier[externalOrderIdServiceApi]": "PreOrder ID",
  "externalIdentifier[externalOrderIdTroubleTicketApi]": "Trouble Ticket Order Number",
  "externalIdentifier[technicalLineIdentifier]": "Technical Line Identifier",
  "externalIdentifier[bnetzaId]": "Process Number (BNetzA)",
  "externalIdentifier[homeId]": "Home ID",
  "externalIdentifier[ONT]": "ONT-SerialNumber",
  "add_note": "Add Note",
  "add_internal_note": "Add Internal Note",
  "note_external_warning": "Notice: In principle, messages are to be used exclusively in exceptional cases to provide additional information to the (clearing) partner.\nMessages are forwarded to the respective partner and serve communication purposes only.\n\nNo data changes may be made or transmitted via messages.\n\nHowever, it is possible to use a message, for example, to request a change of the ticket status to \"Request additional information\" so that this status change can subsequently be carried out properly within the system.",
  "note_external_warning_important": "Please note:\nSending a message does not result in an automatic status change.",
  "note_internal_visibility": "Internal notes remain visible only inside the platform and are not transmitted to the partner.",
  "add_status_change_reason": "Add Status Change Reason",
  "change_ticket_severity": "Change Ticket Severity",
  "updated_ticket_severity": "Updated Clearing Ticket Severity to {{severity}}",
  "assign_to": "Assign to",
  "retry_sync": "Retry Sync",
  "bulk_ticket_assignment": "Bulk Ticket Assignment",
  "clearing_ticket_sync": "Sync of the Clearing Ticket",
  "logout": "Logout",
  "my_account": "My Account",
  "update_password": "Update Password",
  "username": "Username",
  "e_mail": "E-Mail",
  "e_mail_verified": "E-Mail Verification",
  "user_roles": "User Roles",
  "user_account_hint": "Overview of information related to Clearing Platform & manage your account.",
  "clearing_ticket_resolution": "Clearing Ticket Resolution",
  "clearing_ticket_resolved": "Successfully resolved the ticket",
  "resolved_successfully_guideline": "If the request of the originator is fulfilled by the recipient, the clearing ticket must be reported back as 'positively resolved'. If the request is not fulfilled or is not justified, the clearing ticket must be reported back as 'negatively resolved'.",
  "clearing_ticket_unassigned": "Successfully unassigned the ticket",
  "clearing_ticket_assigned_to": "Successfully assigned Ticket to {{username}}",
  "started_watching_ticket": "Ticket {{id}} added to Watching Tickets",
  "removed_watching_ticket": "Ticket {{id}} removed from Watching Tickets",
  "clearing_ticket_status_changed": "Successfully changed ticket status to {{status}}",
  "note_added": "Successfully added ticket note",
  "internal_note_added": "Successfully added internal note",
  "sync_initialized": "Sync Operation initialized",
  "sync_error_message": "An error occurred previously during the {{action}}. Would you like to attempt the Sync Operation again?",
  "processor_selection_required": "Processor selection required. Please choose a processor from the dropdown menu to continue.",
  "CREATE_TICKET": "Creation of a ticket",
  "ADD_TICKET_NOTE": "Adding ticket note",
  "SET_TICKET_DATA": "Setting clearing data",
  "SET_TICKET_RESOLVED": "Setting the ticket to resolved",
  "SET_TICKET_SEVERITY": "Changing the ticket severity",
  "SET_TICKET_STATUS": "Setting ticket status",
  "bulk_assignment_done": "Successfully bulk assigned the tickets",
  "bulk_unassignment_done": "Successfully bulk unassigned the tickets",
  "lang_en": "English",
  "lang_de": "German",
  "mark_as_read": "Mark as Read",
  "not_synced": "Not Synced",
  "bulk_options": "Bulk Options",
  "save": "Save",
  "reason_required": "Status change reason is required!",
  "cancel": "Cancel",
  "action_description": {
    "Initial": "Initial",
    "Start": "Start",
    "Finish": "Finish",
    "Accept Resolution": "Accept Resolution",
    "Reject Resolution": "Reject Resolution",
    "Cancel": "Cancel",
    "Archive": "Archive",
    "Request Information": "Request Information",
    "Add Information": "Add Information",
    "Indicate Blockage": "Indicate Blockage",
    "Resume Work": "Resume Work",
    "Unknown": "Unknown"
  },
  "new_issue_created": "New ticket created",
  "ticket_successfully_assigned_to_you": "Ticket successfully assigned to you",
  "name_field_must_not_be_empty": "Name field must not be empty!",
  "successfully_updated_template": "Successfully updated template",
  "successfully_created_template": "Successfully created new template!",
  "update_template_name": "Update template name",
  "add_template_name": "Add Template Name",
  "form_submission_error": "Form Submission Error",
  "review_the_form": "Please review the form and fill in all required fields before submitting.",
  "attach": "Attach",
  "add_clearing_ticket_data": "Add Clearing Ticket Data",
  "add_clearing_data_description_start": "Please provide all the necessary details to complete the clearing ticket data. Ensure all required fields marked with an asterisk",
  "add_clearing_data_description_end": "are filled out correctly. This information will help us process the ticket according to the selected ticket scenario.",
  "change_type": {
    "ticket_create": "Ticket created",
    "note_add": "Note added",
    "internal_note_add": "Internal note added",
    "status_change": "Status changed",
    "severity_change": "Severity changed",
    "requested_resolution_date_change": "Requested resolution date changed",
    "data_change": "Data changed",
    "attachment_add": "Resolve attachment added",
    "assignment_change": "Assignment changed",
    "unknown": "Unknown change"
  },
  "calendar": {
    "firstDayOfWeek": 1,
    "dayNames": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "dayNamesShort": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "dayNamesMin": [
      "Su",
      "Mo",
      "Tu",
      "We",
      "Th",
      "Fr",
      "Sa"
    ],
    "monthNames": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "monthNamesShort": [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "today": "Today",
    "clear": "Clear"
  },
  "notification": {
    "ticket_created": "Ticket created",
    "data_changed": "Data changed",
    "note_added": "Note added",
    "ticket_resolved": "Ticket resolved",
    "severity_changed": "Severity has been changed to: {0}",
    "status_changed": "Status has been changed to: {0}"
  },
  "internal_note": "Internal",
  "time_ago": {
    "just_now": "just now",
    "minute_ago": "minute ago",
    "minutes_ago": "{0} minutes ago",
    "hour_ago": "hour ago",
    "hours_ago": "{0} hours ago",
    "day_ago": "day ago",
    "days_ago": "{0} days ago"
  },
  "click_to_change_severity": "Click to change severity",
  "ticket_exceeded_sla_resolution_time": "Resolution deadline exceeded",
  "ticket_exceeds_sla_warning_time_soon": "Resolution deadline approaching",
  "ticket_due_reached": "Resolution deadline approaching",
  "ticket_due_exceeded": "Resolution deadline exceeded",
  "partnership_management": "Partnership Management",
  "partnership_description": "Here you can view & manage partnerships & it's specifications",
  "partnerships": "Partnerships",
  "create_partnership": "Create Partnership",
  "specification_name": "Specification Name",
  "partners": "Partners",
  "no_partnerships_found": "No partnerships found.",
  "edit_partnership": "Edit Partnership",
  "here_you_can_create_partnership": "Here you can create a partnership",
  "here_you_can_edit_partnership": "Here you can edit a partnership",
  "partnership_specification": "Partnership Specification",
  "partnership_identification": "Partnership Identification",
  "partner_id": "Partner ID",
  "partner_name": "Partner Name",
  "partner_characteristics": "Partner Characteristics",
  "characteristic_name": "Characteristic Name",
  "characteristic_value": "Characteristic Value",
  "remove_characteristic": "Remove characteristic",
  "manage_partnership": "Manage Partnership",
  "error_fetching_partnership": "Error fetching partnership",
  "here_you_can_manage_partnership": "Here you can manage partnership",
  "add_recipients": "Add Recipients",
  "email_partner_error": "Email partner must have at least one recipient! Press enter to save the recipient!",
  "invalid_email": "Invalid email",
  "email_address": "E-Mail Address",
  "delete_record_message": "Do you want to delete this record?",
  "attachment_role_type": "Attachment Role Type",
  "ADDRESS_CHANGE": "Address Change",
  "EXCERPT_PROOF": "Excerpt Proof",
  "PROOF": "Proof",
  "PHONE_NUMBER_LIST": "Phone Number List",
  "HALF_YEARLY_REPORT": "Half-Yearly Report",
  "BNETZA_DOCUMENT": "BNetzA Document",
  "BUILDER_SERVICE_INVOICE": "Builder Service Invoice",
  "OTHER": "Other",
  "confirm_navigation": "Confirm Navigation",
  "changes_will_be_lost": "Unsaved changes will be lost. Leave the page?",
  "nav_confirm_yes": "Leave",
  "nav_confirm_no": "Stay",
  "ticket_not_synced": "This ticket has not been successfully synchronized with the partner platform instance. Please sync the ticket before proceeding with any actions. Failed action {{action}}.",
  "ticket_email_not_sent": "Email notification was not sent successfully. Failed action {{action}}.",
  "resend_email": "Resend email",
  "default_recipients": "Default recipients per main scenario",
  "apply_to_subscenarios": "Apply to sub-scenarios",
  "inherit_from_group": "Inherited from group",
  "save_query": "Save Query",
  "load_query": "Load Query",
  "load_saved_query": "Load Saved Query",
  "select_saved_query": "Select a saved query:",
  "query_name": "Query Name",
  "enter_query_name": "Enter a name for your query",
  "no_saved_queries_found": "No saved queries found",
  "delete_query": "Delete query",
  "load": "Load",
  "query_deleted_successfully": "Query deleted successfully",
  "failed_to_load_saved_queries": "Failed to load saved queries",
  "failed_to_delete_query": "Failed to delete query",
  "export": "Export",
  "attachments_help": "Maximum file size allowed",
  "no_entries": "No entries available. Click on ",
  "add_entry_hint": ", to add entry.",
  "download": "Download",
  "need_additional_help": "Need Additional Help",
  "contact_support_team": "For any questions, technical issues, or support requests related to the Clearing Platform, please contact the BITConEx support team at",
  "additional_support": "The support team can assist you with user access, system behavior, configuration settings, and any other issues encountered while using the platform.\n\nFor detailed guidance, you can also download the full Clearing Platform Help Manual.",
  "invalid_file_size_summary": "{0} Invalid File Size,",
  "invalid_file_size_detail": "Maximum file size is {0}.",
  "no_partner_light_configurations": "No Light Partner Configurations found.",
  "itu_code": "ITU Code",
  "new_light_partner_config": "Create New Light Partner Configuration",
  "edit_light_partner_config": "Edit Light Partner Configuration",
  "search_by_itu_code": "Search by ITU-Code",
  "search_by_email_address": "Search by E-Mail Address",
  "are_you_lost": "Are you lost?",
  "page_not_found": "Sorry, we couldn't find the page.",
  "back_to_home": "Go back to Home page",
  "release_notes": {
    "empty_message": "No release notes available",
    "empty_description": "Check back later for updates and new features.",
    "feature": "Feature",
    "fix": "Fix",
    "improvement": "Improvement",
    "security": "Security",
    "breaking_change": "Breaking Change"
  },
  "input_needed_required_fields": "Input needed, fill out required fields (*)",
  "switch_to_dark_theme": "Switch to dark theme",
  "switch_to_light_theme": "Switch to light theme",
  "waiting_target_resolution": "Waiting for target resolution",
  "related": "Related",
  "related_ticket": "Related ticket",
  "resolve_target": "Resolve target",
  "target_itu_code": "Target ITU code",
  "select_target_organization": "Select target organization",
  "target_resolved_success": "Target organization resolved successfully",
  "no_target_organization_available": "No target organization is available for this ticket",
  "bulk_resolve_target": "Bulk resolve target",
  "confirm_bulk_resolve_target": "Resolve target for {{count}} selected tickets?",
  "no_waiting_proxy_tickets_selected": "No waiting proxy tickets selected",
  "bulk_target_resolved_success": "{{count}} tickets resolved successfully"
}
